import { Model } from "@vuex-orm/core";
import CustomerLookup from "./CustomerLookup";
import Customer from "./Customer";
import ContactInfo from "./ContactInfo";
import AccountPhone from "./AccountPhone";

export default class Call extends Model {
  static entity = "calls";

  static fields() {
    return {
      // createdAt: this.attr(),
      // updatedAt: this.attr(),
      isDirty: this.boolean(false),

      id: this.attr(),
      childId: this.attr().nullable(),
      fromPhone: this.attr(),
      toPhone: this.attr(),
      isInbound: this.boolean(true),
      startTime: this.attr().nullable(),
      durationSeconds: this.number(0),
      recordingUrl: this.string().nullable(),
      recordingUploadComplete: this.boolean(false),
      recordingExternalId: this.attr().nullable(),
      recordingDurationSeconds: this.number().nullable(),
      recordingType: this.attr().nullable(),
      transcription: this.string().nullable(),
      customerId: this.number().nullable(),
      contactInfoId: this.number().nullable(),
      accountPhoneNumberId: this.number().nullable(),
      // createdAt: this.attr().nullable(),
      viewedAt: this.attr().nullable(),
      isUnread: this.boolean(),

      customerLookup: this.belongsTo(CustomerLookup, "customerId"),
      customer: this.belongsTo(Customer, "customerId"),
      // contactInfo: this.belongsTo(ContactInfo, "contactInfoId"),
      // account_phone: this.belongsTo(AccountPhone, "account_phone_id")
    };
  }

  static mutators() {
    return {
      createdAt(value) {
        if (typeof value == "string") {
          value = Date.parse(value);
        }
        return value;
      },
      updatedAt(value) {
        if (typeof value == "string") {
          value = Date.parse(value);
        }
        return value;
      },
      startTime(value) {
        if (typeof value == "string") {
          value = Date.parse(value);
        }
        return value;
      },
      viewedAt(value) {
        if (typeof value == "string") {
          value = Date.parse(value);
        }
        return value;
      }
    };
  }
}
